<template>
  <!-- 主框架 -->
  <div  class="maindiv">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
      <path fill="#0099ff" fill-opacity="1"
        d="M0,192L48,197.3C96,203,192,213,288,229.3C384,245,480,267,576,250.7C672,235,768,181,864,181.3C960,181,1056,235,1152,234.7C1248,235,1344,181,1392,154.7L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z">
      </path>
    </svg>
    <div class="user">
      <i class="fa fa-user"></i>
      <div class="head">{{headText}}</div>
    </div>
    <div class="container">
      <!-- 免密码登录 -->
      <div :style="loginCss" class="box login">
        <div class="form-content">
          <h1>免密码登录</h1>
          <form action="#" style="height: 250px;justify-content: space-between" class="form">
            <div>
              <i class="fa fa-phone"></i>
              <input type="text" v-model="newphone" placeholder="请输入手机号">
            </div>
            <div style="position: relative;">
              <i class="fa fa-key"></i>
              <input type="text" v-model="code" placeholder="请输入验证码">
              <!-- <button>获取验证码</button> -->
              <p @click="getCode" :class="disabledbtn== false?'chose':'other'">{{btntext}}</p>
            </div>
            <!-- <div @click="signInClick" class="btn">
              登录
            </div> -->
            <el-button :loading="signInClickloading" @click="signInClick" type="primary" class="btn" round>登录</el-button>
          </form>
          <p class="btn-something">
            未注册手机验证后自动登录！ <span @click="signupClick" class="signupbtn">账号密码登录</span>
          </p>
        </div>
      </div>
      <!-- 账号密码登录 -->
      <div :style="signupCss" class="box signup">
        <div class="form-content">
          <h1>账号密码登录</h1>
          <form action="#" style="height: 250px;justify-content: space-between" class="form">
            <div>
              <i class="fa fa-user-o"></i>
              <input v-model="userName" type="text" placeholder="手机号或邮箱">
            </div>
            <div>
              <i class="fa fa-key"></i>
              <input v-model="userPw" type="password" placeholder="请输入密码">
            </div>
            <!-- <div  @click="signInClick1" class="btn">
              登录
            </div> -->
            <el-button :loading="signInClickloading1" @click="signInClick1" type="primary" class="btn" round>登录</el-button>
          </form>
          <p class="btn-something">
            开始登录吧！ <span @click="loginClick" class="loginbtn">免密登录</span>
          </p>
        </div>
      </div>
    </div>
    <div  class="footerdiv">
      <!-- 黔ICP备2022003883号-1 -->
      <a style="color: #fff;" target="_blank" href="https://beian.miit.gov.cn">黔ICP备2022003883号-1</a>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  var countdown = 60;
  export default {
    data() {
      return {
        signInClickloading:false,
        signInClickloading1:false,
        loginCss: "transform: rotateY(0deg)",
        signupCss: "transform: rotateY(-108deg)",
        headText: "password free login",
        loginType: '投稿人',
        loginType1: '投稿人',
        newphone: '',//手机号
        code: '',//验证码
        sccode: "",//生成验证码
        btntext: '获取验证码',
        disabledbtn: false,

        userName:'',//账号密码登录的账号
        userPw:'',//账号密码登录的密码
      }
    },
    //初始化方法
    mounted() {
      // console.log(JSON.parse(this.baseUrl.getCookie("userInfo")));
    },
    //创建方法
    methods: {
      //注册
      signupClick() {
        this.loginCss = "transform: rotateY(108deg)";
        this.signupCss = "transform: rotateY(0deg)"
        this.headText = "account secret login";
      },
      //登录
      loginClick() {
        this.loginCss = "transform: rotateY(0deg)";
        this.signupCss = "transform: rotateY(-108deg)"
        this.headText = "password free login";
      },
      //免密码登录
      signInClick() {
        if (!this.newphone) {
          this.$Message.error('手机号不能为空！');
          return;
        }
        if (!this.code) {
          this.$Message.error('验证码不能为空！');
          return;
        }
        if (this.code != this.sccode) {
          this.$Message.error('验证码不正确！');
          return;
        }
        this.signInClickloading = true;
        let params = new FormData(); // 创建form对象
        params.append("phone", this.newphone); // 手机号
        params.append("passwd", ""); //密码
        params.append("account", ""); //账密登录
        axios.post(this.baseUrl.hbjx + "/user/login", params).then((res) => {
          if (res.data.code=="200") {
            this.baseUrl.setCookie("userInfo",JSON.stringify(res.data.userInfo),1);
            var localState = localStorage.getItem("pageinfo")||"";
            if (localState!="") {
              var toUrl="/pageInfo?"+localState.split("?")[1];
              this.signInClickloading = false;
              console.log(toUrl);
              this.$router.push(toUrl);
              this.$Message.success('登录成功！');
            }else{
              this.signInClickloading = false;
              this.$router.push('/homepage');
              this.$Message.success('登录成功！');
            }
          }
        });
      },
      //账号密码登录
      signInClick1() {
        if (!this.userName) {
          this.$Message.error('账号不能为空！');
          return;
        }
        if (!this.userPw) {
          this.$Message.error('密码不能为空！');
          return;
        }
        this.signInClickloading1 = true;
        let params = new FormData(); // 创建form对象
        params.append("phone", ""); // 手机号
        params.append("passwd", this.baseUrl.encode(this.userPw)); //密码
        params.append("account", this.userName); //账密登录
        axios.post(this.baseUrl.hbjx + "/user/login", params).then((res) => {
          if (res.data.code=="200") {
            this.baseUrl.setCookie("userInfo",JSON.stringify(res.data.userInfo),1);
            var localState = localStorage.getItem("pageinfo")||"";
            if (localState!="") {
              var toUrl="/pageInfo?"+localState.split("?")[1];
              localStorage.removeItem("pageinfo");
              this.$router.push(toUrl);
              this.$Message.success('登录成功！');
              this.signInClickloading1 = false;
            }else{
              this.$router.push('/homepage');
              this.$Message.success('登录成功！');
              this.signInClickloading1 = false;
            }
 
          }else{
            this.$Message.error('账号或密码不正确！');
            this.signInClickloading1 = false;
          }
        });
      },
      settime() {
        if (countdown == 0) {
          this.btntext = "获取验证码";
          this.disabledbtn = false;
          countdown = 60;
          return;
        } else {
          this.btntext = countdown + '秒后可重发';
          this.disabledbtn = true;
          countdown--;
        }
        setTimeout(()=> {
          this.settime();
        }, 1000)
      },
      //获取验证码
      getCode() {
        if (!this.newphone) {
          this.$Message.error('手机号不能为空！');
          return;
        }
        if (this.newphone.length != 11) {
          this.$Message.error('手机号格式不正确！');
          return;
        }
        this.sccode = this.baseUrl.generateCode() ;
        let params = new FormData(); // 创建form对象
        params.append("phone", this.newphone); // 手机号
        params.append("verifyCode", this.baseUrl.encode(this.sccode)); //验证码
        axios.post(this.baseUrl.hbjx + "/code/toPhone", params).then((res) => {
          if (res.data == 'OK') {
            this.$Message.success('验证码已发送，请注意查收!');
            this.settime();
          }
        });
      }
    }
  }
</script>
<style scoped>
  @import "./font-awesome-4.7.0/css/font-awesome.min.css";
  @import "./index.css";

  .maindiv::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #3399ff;
    clip-path: circle(20% at 100% 0);
  }

  .other {
    position: absolute;
    top: 19px;
    right: 15px;
    font-weight: bold;
    color: rgb(198, 198, 198);
    pointer-events: none;
  }

  .chose {
    position: absolute;
  top: 19px;
  right: 15px;
  color: #6395f0;
  font-weight: bold;
  cursor: pointer;
 
  }
  .footerdiv {
    
    position: absolute;
    bottom: 20px;
    width: 100%;
    height: 40px;
    text-align: center;
    line-height: 40px;
    font-size: 12px;
    font-weight: 400;
    color: #495770;
  }
</style>


// WEBPACK FOOTER //
// src/components/Login/login.vue